export default "/images/vendor/flag-icon-css/flags/1x1/un.svg?19c1ad320e901a90c0e31c38039a0f27";